export default {
  en: 'en',
  demo: 'demo-form',
  notFound: 'not-found',
  activities: 'activities',
  activity: 'activite',
  resources: 'resources',
  artworks: 'artworks',
  artwork: 'artwork',
  uiKit: '/en/ui-kit',
  search: '/en/search',
};



// WEBPACK FOOTER //
// ./src/config/locales/en/routes.js